import React, { useRef, useMemo } from "react";
import { get } from "lodash";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Flex from "../layouts/Flex";
import Upload from "@mui/icons-material/Upload";

const FormikFileField = ({ formik, name, label, accept, disabled }) => {
  const inputRef = useRef(null);
  const file = get(formik.values, name);
  const hasError = get(formik.touched, name) && Boolean(get(formik.errors, name));

  const helperText = useMemo(() => {
    if (hasError) {
      return get(formik.errors, name);
    }
    return '';
  }, [formik, name, hasError]);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (event) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      formik.setFieldValue(name, selectedFile);
    }
  };

  return (
    <FormControl fullWidth error={hasError}>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        style={{ display: 'none' }}
        disabled={disabled}
      />
      <Flex alignItems="center" gap={2}>
        <Button
          variant="outlined"
          onClick={handleClick}
          startIcon={<Upload />}
          disabled={disabled}
        >
          {label}
        </Button>
        {file && (
          <Typography variant="body2" color="text.secondary">
            {file.name}
          </Typography>
        )}
      </Flex>
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export default FormikFileField;
